import Tab from "components/Tab";
import * as React from 'react';
export default {
  Tab,
  React
};